import { render, staticRenderFns } from "./DDTView.vue?vue&type=template&id=5d41ba8d&"
import script from "./DDTView.vue?vue&type=script&lang=js&"
export * from "./DDTView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports